(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["paws-halloween-effects"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('paws-halloween-effects')){
  customElements.define('paws-halloween-effects',class extends HTMLElement{
    connectedCallback(){
      const button=this.querySelector('button');
      if(!button||button.dataset.ready)return;
      button.dataset.ready='true';
      const update=paused=>{this.classList.toggle('pc-spooky--paused',paused);button.setAttribute('aria-pressed',String(paused));button.textContent=paused?button.dataset.play:button.dataset.pause;};
      if(Date.now()>=Date.parse(this.dataset.pcHalloweenUntil))return;
      try{update(sessionStorage.getItem('paws-halloween-paused')==='true');}catch(e){}
      button.addEventListener('click',()=>{const paused=!this.classList.contains('pc-spooky--paused');update(paused);try{sessionStorage.setItem('paws-halloween-paused',String(paused));}catch(e){}});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
